import React, {Component} from 'react';
import {Card} from 'semantic-ui-react';
import {connect} from 'react-redux';
import {Actions} from '../../../../../common/actions';
import Message from '../message/Message';
import './record.scss';

class Record extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'text': '',
    };
    this.messageContainer = null;
    this.setMessageContainerRef = (element) => {
      this.messageContainer = element;
    };
  }

  componentDidMount() {
    const {rsrId} = this.props;
    this.props.fetchRecordMessages(rsrId);
  }

  componentDidUpdate() {
    const height = this.messageContainer.scrollHeight;
    this.messageContainer.scrollTo(0, height);
  }

  keyPress = (event) => {
    const textLength = this.state.text.length;
    const {userCreated, model, chassis, rsrId} = this.props;

    const data = {
      'message': this.state.text,
      'idFTR': rsrId,
      'RSRNo': rsrId,
      'userCreated': userCreated,
      'model': model,
      'chassis': chassis,
    };

    if (event.key === 'Enter') {
      if (textLength >= 2) {
        this.props.addRecordMessage(data);
        this.setState({'text': ''});
      }
      event.preventDefault();
    }
  }

  handleChange = (event) => {
    this.setState({'text': event.target.value});
  }

  render() {
    const {text} = this.state;
    const {records, user} = this.props;

    return (
      <div className="glossary-tab">
        <Card fluid raised>
          <div className="container__record">
            <div id="message-container" className="container__record-messages" ref={this.setMessageContainerRef}>
              {records.map((record) => (
                <Message
                  key={record.id}
                  date={record.dateSend}
                  user={record.user === user.toUpperCase()}
                  username={record.user}
                  message={record.message}
                />
              ))}
            </div>
            <div className="container__record-controls">
              <textarea
                value={text}
                rows="1"
                onKeyPress={this.keyPress}
                onChange={this.handleChange}
                placeholder="Escribe un mensaje......"
                type="text"
                className="container__record-controls-textArea"
              ></textarea>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'records': state.recordFTR.record,
    'user': state.session.user,
    'idForm': state.templateFTR.formId,
    'rsrId': state.templateFTR.formNumber,
    'userCreated': state.templateFTR.generalInfo.user,
    'chassis': state.templateFTR.chassisInfo.chassis,
    'model': state.templateFTR.chassisInfo.modelName,
  };
};

const {fetchRecordMessages, addRecordMessage} = Actions;

export default connect(
  mapStateToProps,
  {fetchRecordMessages, addRecordMessage}
)(Record);
